/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Online_Digital24Inputs */

const en__field_enum_csjensblank_online_digital24 = /** @type {(inputs: _Field_Enum_Csjensblank_Online_Digital24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`online`)
};

const de__field_enum_csjensblank_online_digital24 = /** @type {(inputs: _Field_Enum_Csjensblank_Online_Digital24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`online`)
};

/**
* | output |
* | --- |
* | "online" |
*
* @param {_Field_Enum_Csjensblank_Online_Digital24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_online_digital24 = /** @type {((inputs?: _Field_Enum_Csjensblank_Online_Digital24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Online_Digital24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_online_digital24(inputs)
	return de__field_enum_csjensblank_online_digital24(inputs)
});
export { _field_enum_csjensblank_online_digital24 as "_field_enum_CSJENSBLANK_ONLINE_DIGITAL" }